import React, { FC } from "react"
import { cva } from "class-variance-authority"
import {
  MARK_BOLD,
  MARK_ITALIC,
  MARK_STRIKE,
  MARK_STYLED,
  MARK_UNDERLINE,
  NODE_PARAGRAPH,
  render,
} from "storyblok-rich-text-react-renderer"

import { cn } from "@/lib/utils"
import { renderRichTextChildrenOrBreak } from "@/components/ui/helpers/richtextRenderer"
import { UbRichTextStoryblok } from "@/components/storyblok/component-types"

const textColor = cva("", {
  variants: {
    color: {
      "text-primary": "text-primary",
      "text-secondary": "text-secondary",
      "text-destructive": "text-destructive",
      "text-muted": "text-muted",
      "text-accent": "text-accent",
      "text-white": "text-white",
      "text-gray": "text-gray",
    },
  },
  defaultVariants: {
    color: "text-primary",
  },
})

interface UbRichTextProps {
  blok: UbRichTextStoryblok
}

const UbRichText: FC<UbRichTextProps> = ({ blok }) => {
  return render(blok.content, {
    markResolvers: {
      [MARK_BOLD]: (children) => <span className={"font-bold"}>{children}</span>,
      [MARK_ITALIC]: (children) => <span className={"italic"}>{children}</span>,
      [MARK_UNDERLINE]: (children) => <span className={"underline"}>{children}</span>,
      [MARK_STRIKE]: (children) => <span className={"line-through"}>{children}</span>,
      // eslint-disable-next-line react/prop-types
      [MARK_STYLED]: (children, props) => <span className={cn(textColor({ class: props.class }))}>{children}</span>,
    },
    nodeResolvers: {
      [NODE_PARAGRAPH]: (children) => {
        return <>{renderRichTextChildrenOrBreak(children)}</>
      },
    },
  })
}

export default UbRichText
